/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useNotificationItemFrameStyles = makeStyles(theme => ({
  root: {
    padding: '16px 20px 15px 5px',
    flexDirection: 'column',
    // marginLeft: "16px",
    flex: 1,
    alignItems: 'flex-start',
    position: 'relative',
    width: 'auto',
    '&:not(:last-child)': {
      borderBottom: '1px solid #EEEEEE',
    },
    '&$withActions': {
      paddingBottom: '3px',
    },
    cursor: 'pointer',
  },
  withActions: {},
  actions: {
    display: 'flex',
    flexWrap: 'nowrap',
    margin: '0 -5px',
  },
  actionButton: {
    padding: '13px 12px',
    color: theme.palette.tertiary.main,
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 600,
    flex: '1 1 auto',
    borderRadius: '6px',
  },
  firstButton: {},
  secondButton: {
    color: theme.palette.text.primary,
  },
  notRead: {
    paddingLeft: '25px',
    '&:before': {
      content: "''",
      color: '#EE2B24',
      backgroundColor: 'currentColor',
      position: 'absolute',
      top: '32px',
      left: '5px',
      width: '6px',
      height: '6px',
      borderRadius: '50%',
    },
  },
  primaryText: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: 'bold',
    paddingRight: '8px',
  },
  secondaryText: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    lineHeight: '18px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    fontWeight: 400,
  },
  datetime: {
    paddingLeft: '10px',
    maxWidth: '140px',
    flex: '0 0 auto',
  },
  clearBtn: {
    padding: 0,
    position: 'absolute',
    top: 0,
    right: 0,
  },
}));
